<template>
    <v-dialog v-model="show" max-width="80vw">
        <v-form
            ref="form"
            v-model="valid"
            @submit.prevent="submit"
            lazy-validation
        >
            <v-card>
                <v-card-title>
                    <span class="headline">Inventory Entry</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12" sm="12">
                                <v-autocomplete
                                    v-model="form.maintenance_item_id"
                                    :items="items"
                                    label="Maintenance Item"
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    v-model="form.quantity"
                                    label="Initial Stock"
                                    required
                                    prepend-icon="mdi-package-variant-closed"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    v-model="form.comments"
                                    label="Comments"
                                    prepend-icon="mdi-comment"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="3">
                                <v-text-field
                                    v-model="form.unit_cost"
                                    label="Unit Cost"
                                    prepend-icon="mdi-currency-usd"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-text-field
                                    v-model="form.tax_rate"
                                    label="Tax Rate"
                                    prepend-icon="mdi-percent"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-text-field
                                    v-model="form.subtotal_cost"
                                    label="Subtotal Cost"
                                    prepend-icon="mdi-currency-usd"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-text-field
                                    v-model="form.total_cost"
                                    label="Total Cost"
                                    prepend-icon="mdi-currency-usd"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="6">
                                <v-autocomplete
                                    v-model="form.region_id"
                                    :items="regions"
                                    item-text="name"
                                    item-value="id"
                                    label="Region"
                                    prepend-icon="mdi-map-marker"
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-autocomplete
                                    v-model="form.maintenance_vendor_id"
                                    :items="vendors"
                                    item-text="name"
                                    item-value="id"
                                    label="Maintenance Vendor"
                                    prepend-icon="mdi-account"
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="show = false"
                        >Close</v-btn
                    >
                    <v-btn color="blue darken-1" text type="submit">
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script>
import axios from 'axios';
export default {
    name: 'NewInventoryEntry',
    props: {
        dialog: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            valid: false,
            form: {
                name: '',
                maintenance_item_id: '',
                quantity: '', //Stock
                comments: '',
                unit_cost: '',
                total_cost: '',
                region_id: '',
                maintenance_vendor_id: ''
            },
            vendors: [],
            regions: [],
            items: []
        };
    },
    computed: {
        show: {
            get() {
                return this.dialog;
            },
            set(val) {
                this.$emit('update:dialog', val);
            }
        }
    },
    mounted() {
        if (this.vendors.length === 0) {
            axios.get('/v2/maintenance/vendors').then(response => {
                this.vendors = response.data;
            });
        } else {
            console.log('Vendors already loaded');
        }
        if (this.regions.length === 0) {
            axios.get('/v2/regions').then(response => {
                this.regions = response.data;
            });
        } else {
            console.log('Regions already loaded');
        }
    }
};
</script>
